export default {
  scenes: {
    briefing: {
      beats: {
        mysteriousAssignment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'elenaBriefingRoom'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Captain Elena Solara receives a new mission from the Galactic Command. She and her crew are to explore an uncharted sector of space, where strange signals have been detected. As Elena reviews the details in her private briefing room, Commander Kael Rhyder enters the room with an unexpected announcement.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'center'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena react to Kael\'s return?',
              choices: [
                {
                  text: 'Professional Dismissal',
                  next: {
                    scene: 'briefing',
                    beat: 'professionalDismissal'
                  }
                },
                {
                  text: 'Personal Reflection',
                  next: {
                    scene: 'briefing',
                    beat: 'personalReflection'
                  }
                }
              ]
            }
          ]
        },
        professionalDismissal: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Commander Rhyder. I didn\'t expect to see you here. Your expertise will be valuable for this mission.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Just following orders, Captain.'
            }
          ],
          next: {
            scene: 'briefing',
            beat: 'missionDetails'
          }
        },
        personalReflection: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'sad',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'sad',
              text: 'I never thought I\'d work with you again after what happened.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We both have our pasts. Let\'s focus on the future.'
            }
          ],
          next: {
            scene: 'briefing',
            beat: 'missionDetails'
          }
        },
        missionDetails: {
          events: [
            {
              type: 'showNarration',
              text: 'The mission briefing continues, detailing the unexplored sector and its possible threats. Elena tries to focus on the task at hand, but her thoughts keep drifting back to Kael.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Our primary goal is to investigate the source of the mysterious signals. Stay alert. This could be dangerous.'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Understood, Captain.'
            }
          ],
          next: {
            scene: 'crewConcern',
            beat: 'preparingForDeparture'
          }
        }
      }
    },
    crewConcern: {
      beats: {
        preparingForDeparture: {
          events: [
            {
              type: 'showLocation',
              locationId: 'solarisInterior'
            },
            {
              type: 'showNarration',
              text: 'As the crew prepares for departure, Elena\'s second-in-command, Commander Zara Lee, approaches with concerns about the mission. Zara notices the tension between Elena and Kael.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena address Zara\'s concerns?',
              choices: [
                {
                  text: 'Reassure Zara',
                  next: {
                    scene: 'crewConcern',
                    beat: 'reassureZara'
                  }
                },
                {
                  text: 'Confide in Zara',
                  next: {
                    scene: 'crewConcern',
                    beat: 'confideInZara'
                  }
                }
              ]
            }
          ]
        },
        reassureZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'This mission is essential. We\'ve trained for this, and we\'re ready. No distractions.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'sad',
              text: 'I hope you\'re right, Captain. Just be careful.'
            }
          ],
          next: {
            scene: 'crewConcern',
            beat: 'boardingTheStarship'
          }
        },
        confideInZara: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'sad',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'sad',
              text: 'It\'s more complicated than that. I don\'t know how to handle Kael\'s return.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'You don\'t have to figure it out right now. Just focus on getting us through this mission.'
            }
          ],
          next: {
            scene: 'crewConcern',
            beat: 'boardingTheStarship'
          }
        },
        boardingTheStarship: {
          events: [
            {
              type: 'showNarration',
              text: 'The crew boards the starship Solaris, a sleek vessel designed for deep-space exploration. As they depart, Elena notices Kael standing at the helm, ready for the mission. The stars outside the viewport beckon, and the weight of the mission—and her past with Kael—hang heavy on her mind.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'There\'s no turning back now.'
            },
            {
              type: 'hideCharacter',
              characterId: 'elena',
              position: 'center'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Captain, all systems are green. We\'re ready for departure.'
            }
          ],
          next: {
            scene: 'intoTheUnknown',
            beat: 'firstSignsOfTrouble'
          }
        }
      }
    },
    intoTheUnknown: {
      beats: {
        firstSignsOfTrouble: {
          events: [
            {
              type: 'showLocation',
              locationId: 'solarisInterior'
            },
            {
              type: 'showNarration',
              text: 'The Solaris enters the uncharted sector. As they approach the source of the strange signals, systems begin to malfunction. The crew is on edge, with some members suspecting sabotage. Elena orders a full investigation.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena handle the tension within the crew?',
              choices: [
                {
                  text: 'Calm and Commanding',
                  next: {
                    scene: 'intoTheUnknown',
                    beat: 'calmAndCommanding'
                  }
                },
                {
                  text: 'Question the Crew\'s Loyalty',
                  next: {
                    scene: 'intoTheUnknown',
                    beat: 'questionCrewLoyalty'
                  }
                }
              ]
            }
          ]
        },
        calmAndCommanding: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Stay focused, everyone. We\'ll get to the bottom of this. Keep your stations.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'Aye, Captain.'
            }
          ],
          next: {
            scene: 'intoTheUnknown',
            beat: 'investigatingTheSource'
          }
        },
        questionCrewLoyalty: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'angry',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'surprised',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'angry',
              text: 'Someone\'s been tampering with the systems. We need to find out who.'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'surprised',
              text: 'Are you sure it\'s sabotage, Captain? It could just be a malfunction.'
            }
          ],
          next: {
            scene: 'intoTheUnknown',
            beat: 'investigatingTheSource'
          }
        },
        investigatingTheSource: {
          events: [
            {
              type: 'showNarration',
              text: 'Elena and Kael work together to uncover the source of the malfunction. As they dig deeper into the ship\'s systems, they uncover something far more sinister than a mere technical issue.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'thinking',
              text: 'This isn\'t just a malfunction. Someone\'s trying to keep us from reaching our destination.'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Then we need to find out who, and why.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.7
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          goToChapter: {
            chapter: 'chapter2'
          }
        }
      }
    }
  }
}
